import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";

function ProductBanner(props) {
    const togglePopupProduct = (productId) =>{
        [].forEach.bind(document.getElementsByClassName(`popup_product ${productId}`),function(itm){
            itm.style.display = "flex";
        })();
    }
  return (
    <div className='flex w-full h-full items-center mb-5 justify-center form1:justify-evenly'>
        <div className='px-16 w-auto max-w-xl space-y-1'>
            <div className='w-full h-40 max-h-40 lg:hidden bg-slate-600'>
                <LazyLoadImage src={props.image} className='w-full h-auto max-h-40 object-cover'></LazyLoadImage>
            </div>

            <div className="title text-center text-primary-100 text-xl font-bold lg:text-left">
                {props.title}
            </div>
            
            <div className="pt-5 text-justify text-sm lg:text-base h-24 overflow-hidden lg:text-left">
                {props.description}
            </div>

            <p className='text-center lg:text-left'>₡ {props.price}</p>

            <div className='w-full flex justify-center pt-5 lg:justify-start'>
                <button
                onClick={() => {togglePopupProduct(props.id)}}
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md border 
                            border-transparent bg-primary-100 px-4 py-1 text-sm font-medium text-white 
                            shadow-sm hover:bg-primary-200"
                >
                Leer más
                </button>
            </div>
        </div>

        <div className='hidden w-auto max-w-lg lg:block bg-slate-600 rounded-blob'>
            <LazyLoadImage src={props.image} className='w-44 h-44 xl:w-60 xl:h-60 form1:w-80 form1:h-80 object-cover rounded-blob'></LazyLoadImage>
        </div>
    </div>
  )
}

export default ProductBanner;
